import React, { useState } from "react";
import PropTypes from "prop-types";
import { contentHeight } from "assets/jss/default/theme.js";
import Grid from "@mui/material/Grid";
import { CaseStreamFeed } from "components/CaseManagement/CaseStream/CaseStreamFeed";
import { UsersProvider } from "contexts/UsersContext";
import { useEffectOnce } from "react-use";
import { useTrackPageView } from "hooks/useTrackPageView";
import { CaseActionsProvider } from "contexts/CaseActionsContext";
import { styled } from "@mui/material/styles";
import { SimilarCasesProvider } from "components/CaseManagement/SimilarCases/SimilarCasesContext";
import { CaseDetailSection } from "components/CaseManagement/CaseDetail/CaseDetailSection";
import { CaseProvider } from "contexts/CaseContext";
import { EventsProvider } from "contexts/EventsContext";

export default function CasePage(props) {
  useTrackPageView("Case Page");
  const caseId = Number(props.match.params.caseid);
  const [casePageSaving, setCasePageSaving] = useState(null);

  // reset tab title to whatever it originally was after leaving the page
  useEffectOnce(() => {
    const tempDocTitle = document.title;
    return () => {
      document.title = tempDocTitle;
    };
  });

  return (
    <CaseProvider caseId={caseId}>
      <EventsProvider caseId={caseId}>
        <SimilarCasesProvider caseId={caseId}>
          <UsersProvider>
            <CaseActionsProvider caseId={caseId}>
              <Grid container>
                <CaseDetailSection
                  caseId={caseId}
                  onChangeCaseSaving={setCasePageSaving}
                />
                <StreamSectionGrid item xs={12} md={6}>
                  <CaseStreamFeed
                    caseId={caseId}
                    casePageSaving={casePageSaving}
                  />
                </StreamSectionGrid>
              </Grid>
            </CaseActionsProvider>
          </UsersProvider>
        </SimilarCasesProvider>
      </EventsProvider>
    </CaseProvider>
  );
}

const StreamSectionGrid = styled(Grid)`
  padding: 0 20px;
  height: ${contentHeight};
  position: relative;
  @media (max-width: 960px) {
    padding: 0px;
  }
`;

CasePage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      caseid: PropTypes.string
    })
  })
};
